<template>
  <div class="quote">
      <q>{{quote}}</q>
      <span>— {{author}}</span>
  </div>
</template>

<script>
export default {
    name: 'Quote',
    props: ['author', 'quote'],
}
</script>
<style >
.quote{
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 0 auto;
  font-size: 1.4rem;
  color: rgb(82, 82, 82);
  font-family: 'Lobster Two', cursive;
  font-weight: 500;
  padding: 2.4rem 0;
}
.quote q{
  text-align: center;
  margin: 1rem 0;
}
.quote > span{
  text-align: center;
  font-size: 1rem;
  font-family: 'Raleway', sans-serif, Helvetica, Arial, sans-serif;
}

</style>